import React, {PropsWithChildren} from 'react';

import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';

import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/de';

import {germanLocale, PASSWORD_EXPIRES_SOON} from '../shared/constants';
import {
  BasketProvider,
  EnumProvider,
  ImageEditorContextProvider,
  ItemSelectionProvider,
  SearchProvider,
  StructureProvider,
  useAuth,
  UserProvider,
} from '../shared/contexts';
import {ToggleColorMode} from '../shared/contexts/colorModeContext';

import PasswordChange from '../features/changePassword/components/PasswordChange';

export const AppProviderLayout: React.FC<PropsWithChildren> = ({children}) => {
  const {passwordChangeProps, closePWDialog, token} = useAuth();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="de"
      localeText={germanLocale}
    >
      <ToggleColorMode active={true}>
        <UserProvider>
          <ImageEditorContextProvider>
            <BasketProvider>
              <SearchProvider>
                <ItemSelectionProvider>
                  <StructureProvider>
                    <EnumProvider>
                      <DndProvider backend={HTML5Backend}>
                        {!!token && (
                          <PasswordChange
                            open={passwordChangeProps.open}
                            onClose={closePWDialog}
                            message={PASSWORD_EXPIRES_SOON.replace(
                              '{}',
                              passwordChangeProps.passwordExpiresInDays.toString(),
                            )}
                            closeButtonText="Überspringen"
                          />
                        )}
                        {children}
                      </DndProvider>
                    </EnumProvider>
                  </StructureProvider>
                </ItemSelectionProvider>
              </SearchProvider>
            </BasketProvider>
          </ImageEditorContextProvider>
        </UserProvider>
      </ToggleColorMode>
    </LocalizationProvider>
  );
};
